"use client";

import { useEffect, useState } from 'react';

export function HydrationDebug() {
  const [isClient, setIsClient] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    console.log('[HydrationDebug] Component mounted');
    setIsClient(true);
    
    // Проверяем различия между серверным и клиентским рендером
    const serverHTML = document.querySelector('html')?.innerHTML;
    console.log('[HydrationDebug] Server HTML length:', serverHTML?.length);
    
    // Проверяем localStorage
    const hasUser = localStorage.getItem('user') !== null;
    console.log('[HydrationDebug] User in localStorage:', hasUser);
    
    setMounted(true);
  }, []);

  // Этот компонент отображает разное содержимое на сервере и клиенте
  // для демонстрации проблемы гидратации
  if (!mounted) {
    return null;
  }

  return (
    <div style={{ display: 'none' }} suppressHydrationWarning>
      <span>Client: {isClient ? 'true' : 'false'}</span>
      <span>Time: {new Date().toISOString()}</span>
    </div>
  );
}

export default HydrationDebug;
